import React, { useEffect, useState } from "react";
import hand from "./handpointer.svg";
import LcIconLink from "../../Generic/LcIconLink";
import "./index.css";

interface Help {
    top?: number | string,
    left?: number | string,
    right?: number | string,
    bottom?: number | string,
    width: string,
    height: string,
    hand?: {
        top?: number | string,
        bottom?: number | string,
        left?: number | string,
        right?: number | string,
        rotate: number
    }
    name: string,
    description?: string,
    onShow?: Function,
    onHide?: Function,
    styleWindow?: React.CSSProperties,
    styleHand?: React.CSSProperties,
}

interface HelperProps {
    list: Help[],
    visible: boolean,
    onClose?: Function
    onInit?: Function
}

const Helper: React.FC<HelperProps> = (props) => {
    //Default
    const helpStart: Help = {
        top: window.innerHeight / 2,
        bottom: window.innerHeight / 2,
        left: window.innerWidth / 2,
        right: window.innerWidth / 2,
        width: "0",
        height: "0",
        name: "Bem vindo a ajuda do HeyHo",
        description: "Você será guiado pelos componentes de tela do novo layout do HeyHo.",
        onShow: () => {
            props.onInit && props.onInit();
        }
    }

    const list = [helpStart, ...props.list];

    const [actualHelp, setActualHelp] = useState(0);
    const [selected, setSelected] = useState<Help>(list[0]);

    const hideAll = () => {
        list.forEach(h => {
            h.onHide && h.onHide();
        });
    }

    useEffect(() => {
        if (props.visible) {
            setActualHelp(0);
            setSelected(list[0]);
            selected.onShow && selected.onShow()
        }
        else {
            hideAll();
        }
    }, [props.visible])

    useEffect(() => {
        let _new = list[actualHelp];
        _new.onShow && _new.onShow();
        setSelected({ ..._new });
    }, [actualHelp])

    const changeActual = (newId: number) => {
        selected.onHide && selected.onHide();
        setActualHelp(newId);
    }

    const onClose = () => {
        props.onClose && props.onClose(false);
    }

    const getStyleWindow = () => {
        let styleWindow = {
            top: selected.top,
            bottom: selected.bottom,
            right: selected.right,
            left: selected.left,
            width: selected.width,
            height: selected.height,
        } as React.CSSProperties;

        if (selected.styleWindow) styleWindow = { ...styleWindow, ...selected.styleWindow };

        return styleWindow;
    }

    const getStyleHand = () => {
        let styleHand = {
            opacity: selected.hand ? "1" : "0",
            top: selected.hand?.top || 0,
            bottom: selected.hand?.bottom || 0,
            right: selected.hand?.right || 0,
            left: selected.hand?.left || 0,
            transform: `translateX(-50%) translateY(-50%) rotate(${selected.hand?.rotate || 0}deg)`
        } as React.CSSProperties;

        if (selected.styleHand) styleHand = { ...styleHand, ...selected.styleHand };

        return styleHand;
    }

    return (

        <div className={`lc-helper${props.visible ? "" : " hide"}`}>
            {
                props.visible &&
                <div className={"body"}>
                    <div
                        className={"window"}
                        style={getStyleWindow()}
                    >
                    </div>
                    <img
                        className={"hand"}
                        src={hand}
                        alt=""
                        style={getStyleHand()}
                    />
                    <div className="text" style={{ top: actualHelp === 0 ? "calc(50vh - 100px)" : "calc(calc(100vh - 200px))" }}>
                        <div className={"name"}>{selected.name}</div>
                        <div className={"description"}>{selected.description}</div>
                        <div className={"navigator"}>
                            {
                                actualHelp < list.length - 1
                                    ? <>
                                        <LcIconLink
                                            icon={"ppi ppi-chevron-double-left"}
                                            size={"big"}
                                            tooltip={"Início"}
                                            onClick={() => {
                                                hideAll();
                                                setActualHelp(1);
                                            }}
                                        />
                                        <LcIconLink
                                            icon={"ppi ppi-arrow-circle-left"}
                                            size={"big"}
                                            tooltip={"Voltar"}
                                            disabled={actualHelp === 0}
                                            onClick={() => {
                                                changeActual(actualHelp - 1)
                                            }}
                                        />
                                        <LcIconLink
                                            icon={"ppi ppi-arrow-circle-right"}
                                            size={"big"}
                                            tooltip={"Avançar"}
                                            disabled={actualHelp === list.length - 1}
                                            onClick={() => {
                                                changeActual(actualHelp + 1)
                                            }}
                                        />
                                        <LcIconLink
                                            icon={"ppi ppi-chevron-double-right"}
                                            size={"big"}
                                            tooltip={"Fim"}
                                            onClick={() => {
                                                hideAll();
                                                setActualHelp(list.length - 1)
                                            }}
                                        />
                                    </>
                                    : <button className={"lc-button bg-info-alt"} onClick={() => onClose()}>Fechar</button>
                            }
                        </div>

                    </div>
                </div>
            }

        </div>
    );
}

export default Helper;